export const AUTH_TOKEN_COOKIE = "auth_token"
export const REFRESH_TOKEN_COOKIE = "refresh_token"

export const authTokenOptions = {
  httpOnly: false, // Client components need to read it
  secure: process.env.NODE_ENV === "production",
  sameSite: "lax" as const,
  path: "/",
  maxAge: 60 * 60, // 1 hour
}

export const refreshTokenOptions = {
  httpOnly: true, // Never exposed to JS
  secure: process.env.NODE_ENV === "production",
  sameSite: "lax" as const,
  path: "/", // Sent with all requests so middleware can read it for token refresh
  maxAge: 60 * 60 * 24 * 90, // 90 days
}

/** Options for deleting the refresh token cookie — must match the set options exactly. */
export const refreshTokenDeleteOptions = {
  path: "/",
  secure: process.env.NODE_ENV === "production",
  sameSite: "lax" as const,
}

/** Client-side only: read auth token from document.cookie */
export function getClientAuthToken(): string | null {
  if (typeof document === "undefined") return null
  const match = document.cookie.match(/(?:^|;\s*)auth_token=([^;]*)/)
  return match ? decodeURIComponent(match[1]) : null
}

/**
 * Returns true if the current auth token is expired or expires within
 * `thresholdSeconds` (default 60s). Returns false if there is no token
 * (user is not logged in — no need to refresh).
 */
export function isTokenExpiredOrExpiringSoon(thresholdSeconds = 60): boolean {
  const token = getClientAuthToken()
  if (!token) return false
  try {
    const payload = JSON.parse(atob(token.split(".")[1]))
    return typeof payload.exp === "number" && Date.now() / 1000 > payload.exp - thresholdSeconds
  } catch {
    return false
  }
}
